import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const PrinterChangeSlice = createSlice({
  name: "PrinterChangeSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PrinterChange: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successPrinterChange: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePrinterChange: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPrinterChange: (state) => {
      state.data = {};
    },
  },
});

export const {
  PrinterChange,
  successPrinterChange,
  failurePrinterChange,
  clearPrinterChange,
} = PrinterChangeSlice.actions;

export default PrinterChangeSlice.reducer;
